import React from "react";

export const PrettyPrint: React.FC<{ obj: any }> = ({ obj }) => {
  return (
    <pre className="col-span-4 max-h-[50vh] overflow-scroll lg:col-span-4">
      {JSON.stringify(obj, null, 2)}
    </pre>
  );
};
